import { useSettings } from "@/hooks/SettingsContext";

export default function Logo({ variant = "dark", size = "md", className = "" }) {
  const { settings } = useSettings();
  const url = settings?.logo_url || "/vc-clay-logo-256.png";
  const light = variant === "light";
  const dim = size === "lg" ? "h-20 w-20 sm:h-24 sm:w-24" : size === "footer" ? "h-14 w-14" : size === "nav" ? "h-9 w-9 sm:h-10 sm:w-10" : "h-12 w-12";
  const nameSize = size === "lg" ? "text-xl sm:text-2xl" : size === "footer" ? "text-lg" : "text-base";
  const subSize = size === "lg" ? "text-xs" : size === "footer" ? "text-[11px]" : "text-[10px]";
  const scriptSize = size === "lg" ? "text-sm" : size === "footer" ? "text-sm" : "text-xs";

  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={url}
        alt="Victory Chapel Christian Church - VC Clay official logo"
        className={`${dim} shrink-0 rounded-full object-cover ${light ? "bg-white p-1 ring-1 ring-white/30" : "bg-white ring-1 ring-navy/10 shadow-soft"}`}
      />
      {size === "nav" ? (
        <span className={`font-display text-base font-800 tracking-tight sm:text-lg ${light ? "text-white" : "text-navy"}`}>
          VICTORY CHAPEL <span className={light ? "text-rose-300" : "text-victory"}>CLAY</span>
        </span>
      ) : (
        <span className="leading-none">
          <span className={`block font-display font-800 tracking-tight ${nameSize} ${light ? "text-white" : "text-navy"}`}>
            VICTORY CHAPEL
          </span>
          <span className={`mt-1 block font-display font-700 uppercase tracking-[0.28em] ${subSize} ${light ? "text-white/60" : "text-navy/55"}`}>
            Christian Church
          </span>
          <span className={`mt-0.5 block font-serif italic tracking-wide ${scriptSize} ${light ? "text-rose-300" : "text-victory"}`}>
            Clay County, Florida
          </span>
        </span>
      )}
    </span>
  );
}
